
export default {
  name: 'PagesCareerHeader',
  data() {
    return {
      filterMenu: [
        {
          id: 1,
          title: 'Карьера',
          path: '/career',
          sub: () => null,
        },
      ],
    }
  },
  mounted() {
    this.$header.setVisibleAdditionalMenu(false)
    this.$header.setAdditionalMenu(null)
    this.$header.setAdditionalMenu({
      logo: null,
      title: 'Карьера',
      menu: this.filterMenu,
    })
  },
  beforeDestroy() {
    this.$header.setVisibleAdditionalMenu(false)
    this.$header.setAdditionalMenu(null)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(_event, el) {
      if (el) {
        const { bottom } = el.getBoundingClientRect()

        if (bottom < 0) {
          this.$header.setVisibleAdditionalMenu(true)
        } else {
          this.$header.setVisibleAdditionalMenu(false)
        }
      }
    },
  },
}
